export const frontmatter = {
    "draft": false,
    "title": "Knowledge Base",
    "description": "Knowledge bases and RAG in OnnIA.",
    "sidebar_label": "Overview",
    "sidebar_group": "reference",
    "sidebar_order": 1
}

export const toc = []